import { SharedModule } from './../shared/shared.module';
import { DataTablesModule } from 'angular-datatables';
import { RouterModule } from '@angular/router';

import { InfoServicePricingComponent } from './info-service-pricing/info-service-pricing.component';
import { InfoServiceOfferingComponent } from './info-service-offering/info-service-offering.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OurStoryComponent } from './our-story/our-story.component';
import { CoreTeamComponent } from './core-team/core-team.component';
import { TimeLineOneComponent } from './our-story/time-line-one/time-line-one.component';
import { TimeLineTwoComponent } from './our-story/time-line-two/time-line-two.component';
import { TimeLineThreeComponent } from './our-story/time-line-three/time-line-three.component';
import { TimeLineFourComponent } from './our-story/time-line-four/time-line-four.component';
import { TimeLineFiveComponent } from './our-story/time-line-five/time-line-five.component';
import { TimeLineSixComponent } from './our-story/time-line-six/time-line-six.component';
import { AdvisorEdgartComponent } from './core-team/advisor-edgart/advisor-edgart.component';
import { AdvisorGodwinComponent } from './core-team/advisor-godwin/advisor-godwin.component';
import { AdvisorKimanairComponent } from './core-team/advisor-kimanair/advisor-kimanair.component';
import { ExecutiveEmmaComponent } from './core-team/executive-emma/executive-emma.component';
import { ExecutiveKanagwaComponent } from './core-team/executive-kanagwa/executive-kanagwa.component';
import { ExecutiveMarrietteComponent } from './core-team/executive-marriette/executive-marriette.component';
import { UsagePolicyComponent } from './usage-policy/usage-policy.component';
import { FaqComponent } from './faq/faq.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';
import { UsageComponent } from './usage/usage.component';
import { PrivacyPolicyComponent } from './usage/privacy-policy/privacy-policy.component';
import { IntroComponent } from './usage/intro/intro.component';
import { GeneralComponent } from './usage/general/general.component';
import { MembershipComponent } from './usage/membership/membership.component';
import { OpenFreeAccessComponent } from './usage/open-free-access/open-free-access.component';
import { BillingComponent } from './usage/billing/billing.component';
import { PasswordsAccountAccessComponent } from './usage/passwords-account-access/passwords-account-access.component';
import { WarrantiesComponent } from './usage/warranties/warranties.component';
import { AvailabilityOfSiteComponent } from './usage/availability-of-site/availability-of-site.component';
import { ThirdPartyLinksComponent } from './usage/third-party-links/third-party-links.component';
import { DisclaimerComponent } from './usage/disclaimer/disclaimer.component';
import { LimitedLiabilityComponent } from './usage/limited-liability/limited-liability.component';
import { IndemnifyComponent as IndemnifyComponent } from './usage/indemnify/indemnify.component';
import { SurvivalComponent } from './usage/survival/survival.component';
import { ChangesComponent } from './usage/changes/changes.component';
import { AssignmentComponent } from './usage/assignment/assignment.component';
import { InjunctionComponent } from './usage/injunction/injunction.component';
import { SeverabilityComponent } from './usage/severability/severability.component';
import { CompleteUnderstandingComponent } from './usage/complete-understanding/complete-understanding.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ImagePreviewComponent } from './gallery/image-preview/image-preview.component';
import { ImageDetailComponent } from './gallery/image-detail/image-detail.component'


@NgModule({
  declarations: [
    InfoServiceOfferingComponent,
    InfoServicePricingComponent,
    OurStoryComponent,
    CoreTeamComponent,
    TimeLineOneComponent,
    TimeLineTwoComponent,
    TimeLineThreeComponent,
    TimeLineFourComponent,
    TimeLineFiveComponent,
    TimeLineSixComponent,
    AdvisorEdgartComponent,
    AdvisorGodwinComponent,
    AdvisorKimanairComponent,
    ExecutiveEmmaComponent,
    ExecutiveKanagwaComponent,
    ExecutiveMarrietteComponent,
    UsagePolicyComponent,
    FaqComponent,
    CookiePolicyComponent,
    UsageComponent,
    PrivacyPolicyComponent,
    IntroComponent,
    GeneralComponent,
    MembershipComponent,
    OpenFreeAccessComponent,
    BillingComponent,
    PasswordsAccountAccessComponent,
    WarrantiesComponent,
    AvailabilityOfSiteComponent,
    ThirdPartyLinksComponent,
    DisclaimerComponent,
    LimitedLiabilityComponent,
    IndemnifyComponent,
    SurvivalComponent,
    ChangesComponent,
    AssignmentComponent,
    InjunctionComponent,
    SeverabilityComponent,
    CompleteUnderstandingComponent,
    AboutUsComponent,
    ImagePreviewComponent,
    ImageDetailComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    DataTablesModule,
    SharedModule
  ],
  exports:[
    InfoServiceOfferingComponent,
    UsagePolicyComponent,
    FaqComponent,
    PrivacyPolicyComponent,
    CookiePolicyComponent,
    UsageComponent,
    InfoServicePricingComponent
  ]
})
export class InfoModule { }
